import NewsPreview from './news-preview';

export default NewsPreview;
